const uischema = (schema) => ({
  type: "VerticalLayout",
  elements: [
    {
      type: "HorizontalLayout",
      elements: [
        {
          type: "Control",
          label: "Tenant Name",
          scope: "#/properties/tenantName",
          options: {
            readonly: true,
          },
        },
        {
          type: "Control",
          label: "Tenant Role",
          scope: "#/properties/tenantUserRoleId",
        },
        ...(schema.properties.expiresAt
          ? [
            {
              type: "Control",
              label: "Expires At",
              scope: "#/properties/expiresAt",
              options: {
                format: "date",
                disablePast: true,
                disablePresent: true,
              },
            },
          ]
          : []),
      ],
    },
  ],
});

export default uischema;
